module.exports = __webpack_public_path__ + "img/lasource-39.d1aea9cc.jpg";